/** @jsxImportSource @emotion/react */

import "./index.css";

import { Modal } from "antd";
import { isMobile } from "router";

import { PromotionDetailStyle } from "./index.style";

interface PromotionDetailProps {
  content?: TrustedHTML;
  isOpen?: boolean;
  onClose?: () => void;
  isSubcribe?: boolean;
}

const PromotionDetail = (props: PromotionDetailProps) => {
  const { content, isOpen = false, onClose } = props;

  // const handleSubscribe = () => {
  //   //
  // };

  const handleClose = () => {
    onClose && onClose();
  };

  return (
    <div css={PromotionDetailStyle.self}>
      <Modal
        wrapClassName="promotion-detail-modal"
        width={isMobile ? "80%" : "1160px"}
        title={null}
        open={isOpen}
        onCancel={handleClose}
        footer={null}
        centered
        closable={false}
        style={{ padding: "30px 0" }}
      >
        <div css={PromotionDetailStyle.content}>
          {content && <div dangerouslySetInnerHTML={{ __html: content }}></div>}
          {/* {isSubcribe && (
            <div css={PromotionDetailStyle.btnSubscribe}>
              <Button type="primary" onClick={handleSubscribe}>
                Subscribe
              </Button>
            </div>
          )} */}
        </div>
      </Modal>
    </div>
  );
};

export default PromotionDetail;
